import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";

// Components
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import FeedbackPopup from "./components/FeedbackPopup/FeedbackPopup";
import VisitorTracker from "./components/VisitorTracker";
import AdminProtectedRoute from "./components/AdminProtectedRoute";

// Pages
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import Projects from "./pages/Projects/Projects";
import Internships from "./pages/Internships/Internships";
import Certificates from "./pages/Certificates/Certificates";
import Skills from "./pages/Skills/Skills";
import Blogs from "./pages/Blogs/Blogs";
import Contact from "./pages/Contact/Contact";
import FeedbackPage from "./pages/FeedbackPage/FeedbackPage";
import Resume from "./pages/Resume/Resume";
import MyActivity from "./pages/MyActivity/MyActivity";
import BookSession from "./pages/BookSession/BookSession";
import ThankYou from "./pages/ThankYou/ThankYou";
import FeedbackSuccess from "./pages/FeedbackSuccess/FeedbackSuccess";
import UnderConstruction from "./pages/UnderConstruction";
import Admin from "./pages/Admin/Admin";
import TrackPage from "./pages/TrackPage";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions/TermsConditions";
import CookiePolicy from "./pages/CookiePolicy/CookiePolicy";

// Events Pages
import Events from "./pages/Events/Events";
import EventDetail from "./pages/Events/EventDetail";
import EventBooking from "./pages/Events/EventBooking";

// Project Detail Pages
import EmployeeDailyTask from "./pages/Projects/Projectdetail/employee-daily-task-allocation-management-system";
import ConvertersAppProject from "./pages/Projects/Projectdetail/converters-app-project";
import RFIDBasedBusNumberAnnounceSystemForBlind from "./pages/Projects/Projectdetail/rfid-based-bus-number-announce-system-for-blind";
import ToDoListApp from "./pages/Projects/Projectdetail/to-do-list-app";
import AiPoweredCommunication from "./pages/Projects/Projectdetail/ai-powered-communication-platform-for-deaf-and-mute";
import CloudVendorApp from "./pages/Projects/Projectdetail/cloudvendor-app-using-java-springboot-using-mysql-jdbc";
import TicTacToeApp from "./pages/Projects/Projectdetail/tic-tac-toe-app";
import SmartExpense from "./pages/Projects/Projectdetail/smart-expense";
import VistaHolidays from "./pages/Projects/Projectdetail/vista-holidays";
import DocuVault from "./pages/Projects/Projectdetail/Docu-Vault";
import PKNotesApp from "./pages/Projects/Projectdetail/notes-app";
import OpsMindAI from "./pages/Projects/Projectdetail/ops-mind-ai";
import AIAdCreativeGenerator from "./pages/Projects/Projectdetail/ai-ad-creative-generator";
import AeroGlassProductLandingPage from "./pages/Projects/Projectdetail/aeroglass-productlanding-page";
import EasyHub from "./pages/Projects/Projectdetail/easy-hub";
import InstagramClone from "./pages/Projects/Projectdetail/instagram-clone";
import LinkedInClone from "./pages/Projects/Projectdetail/linkedin-clone";
import NeonBiteFoodDelivery from "./pages/Projects/Projectdetail/neon-bite-food-Delivery";
import NetflixClone from "./pages/Projects/Projectdetail/netflix-clone";
import SpotifyClone from "./pages/Projects/Projectdetail/spotify-clone";
import TapAcademyClone from "./pages/Projects/Projectdetail/tap-academy-clone";
import VortexCollegeFest from "./pages/Projects/Projectdetail/vortex-college-fest";

// Certificate Detail Pages
import GoogleCertificates from "./pages/Certificates/Certificatedetail/google-certificates";
import InfosysSpringboardCertificates from "./pages/Certificates/Certificatedetail/infosys-springboard-certificates";
import GuviCertificates from "./pages/Certificates/Certificatedetail/guvi-certificates";
import HackerRankCertificates from "./pages/Certificates/Certificatedetail/hacker-rank-certificates";
import GreatLearningCertificates from "./pages/Certificates/Certificatedetail/great-learning-certificates";
import UdemyCertificates from "./pages/Certificates/Certificatedetail/udemy-certificates";
import OneRoadmapCertificate from "./pages/Certificates/Certificatedetail/one-roadmap-certificate";
import AwsCertificates from "./pages/Certificates/Certificatedetail/aws-certificates";
import MicrosoftCertificates from "./pages/Certificates/Certificatedetail/microsoft-certificate";
import LinkedInCertificates from "./pages/Certificates/Certificatedetail/linkedin-certificate";
import OnlineWebinarCertificates from "./pages/Certificates/Certificatedetail/onlinewebinar-certificate";

// Blog Detail Pages
import BlogDetail from "./pages/Blogs/Blogdetail/employee-daily-task-allocation-management-system";
import BlogRFIDBlind from "./pages/Blogs/Blogdetail/rfid-based-bus-number-announce-system-for-blind";
import BlogToDoList from "./pages/Blogs/Blogdetail/to-do-list-app";
import BlogConvertersApp from "./pages/Blogs/Blogdetail/converters-app-project";
import AIPoweredCommunicationBlog from "./pages/Blogs/Blogdetail/ai-powered-communication-platform-for-deaf-and-mute";
import CloudVendorAppBlog from "./pages/Blogs/Blogdetail/cloudvendor-app-using-java-springboot-using-mysql-jdbc";

const TITLE_SUFFIX = "Praveen Kumar B";

const titleMap = {
  "/": "Praveen Kumar B",
  "/about": "About",
  "/projects": "Projects",
  "/internships": "Internships",
  "/certificates": "Certificates",
  "/feedback": "Feedback",
  "/book-session": "Book Session",
  "/under-construction": "Under Construction",
  "/skills": "Skills",
  "/blogs": "Blogs",
  "/events": "Events & Sessions",
  "/contact": "Contact",
  "/resume": "Resume",
  "/my-activity": "My Activity",
  "/thank-you": "Thank You",
  "/feedback-success": "Feedback Success",
  "/privacy-policy": "Privacy Policy",
  "/terms-conditions": "Terms & Conditions",
  "/terms": "Terms & Conditions",
  "/cookie-policy": "Cookie Policy",

  "/projects/projectdetail/employee-daily-task-allocation-management-system":
    "Employee Daily Task Allocation Management System",
  "/projects/projectdetail/converters-app-project":
    "Converters App Project",
  "/projects/projectdetail/rfid-based-bus-number-announce-system-for-blind":
    "RFID Based Bus Number Announce System For Blind",
  "/projects/projectdetail/to-do-list-app":
    "To Do List App",
  "/projects/projectdetail/ai-powered-communication-platform-for-deaf-and-mute":
    "AI Powered Communication Platform For Deaf And Mute",
  "/projects/projectdetail/tic-tac-toe-app":
    "Tic Tac Toe App",
  "/projects/projectdetail/notes-app":
    "PK Notes App",
  "/projects/projectdetail/cloudvendor-app-using-java-springboot-using-mysql-jdbc":
    "CloudVendor App Using Java Spring Boot Using MySQL JDBC",

    "/projects/projectdetail/smart-expense":
    "SmartExpense - Enterprise SaaS Financial Management System",
    "/projects/projectdetail/vista-holidays":
    "Vista Holidays - AI-Powered Travel Platform",
    "/projects/projectdetail/docu-vault":
    "DocuVault - AI-Powered Secure Document Management Platform",
    "/projects/projectdetail/Docu-Vault":
    "DocuVault - AI-Powered Secure Document Management Platform",

  "/ops-mind-ai": "OpsMind AI",
  "/ai-ad-creative-generator": "AI Ad Creative Generator",

  "/projects/projectdetail/aeroglass-productlanding-page": 
    "AeroGlass Product Landing Page",
    
  "/projects/projectdetail/easy-hub": 
    "Easy Hub",
  "/projects/projectdetail/instagram-clone": 
    "Instagram UI Clone",
  "/projects/projectdetail/linkedin-clone": 
    "LinkedIn UI Clone",
  "/projects/projectdetail/neon-bite-food-Delivery": 
    "Neon Bite Food Delivery",
  "/projects/projectdetail/netflix-clone": 
    "Netflix UI Clone",
  "/projects/projectdetail/spotify-clone": 
    "Spotify UI Clone",
  "/projects/projectdetail/tap-academy-clone": 
    "Tap Academy Clone",
  "/projects/projectdetail/vortex-college-fest": 
    "Vortex College Fest Website",

  "/certificates/certificatedetail/google-certificates": "My Google Certifications",
  "/certificates/certificatedetail/microsoft-certificate": "My Microsoft Certifications",
  "/certificates/certificatedetail/linkedin-certificate": "My LinkedIn Certifications",
  "/certificates/certificatedetail/onlinewebinar-certificate": "My Online Webinar Certifications",
  "/certificates/certificatedetail/infosys-springboard-certificates": "My Infosys Springboard Certifications",
  "/certificates/certificatedetail/guvi-certificates": "My GUVI Certifications",
  "/certificates/certificatedetail/hacker-rank-certificates": "My HackerRank Certifications",
  "/certificates/certificatedetail/great-learning-certificates": "My Great Learning Certifications",
  "/certificates/certificatedetail/udemy-certificates": "My Udemy Certifications",
  "/certificates/certificatedetail/one-roadmap-certificate": "My One Roadmap Certifications",
  "/certificates/certificatedetail/aws-certificates": "My AWS Certifications",

  "/Certificates/Certificatedetail/google-certificates": "My Google Certifications",
  "/Certificates/Certificatedetail/microsoft-certificate": "My Microsoft Certifications",
  "/Certificates/Certificatedetail/linkedin-certificate": "My LinkedIn Certifications",
  "/Certificates/Certificatedetail/onlinewebinar-certificate": "My Online Webinar Certifications",
  "/Certificates/Certificatedetail/infosys-springboard-certificates": "My Infosys Springboard Certifications",
  "/Certificates/Certificatedetail/guvi-certificates": "My GUVI Certifications",
  "/Certificates/Certificatedetail/hacker-rank-certificates": "My HackerRank Certifications",
  "/Certificates/Certificatedetail/great-learning-certificates": "My Great Learning Certifications",
  "/Certificates/Certificatedetail/udemy-certificates": "My Udemy Certifications",
  "/Certificates/Certificatedetail/one-roadmap-certificate": "My One Roadmap Certifications",
  "/Certificates/Certificatedetail/aws-certificates": "My AWS Certifications",

  "/blogs/blogdetail/employee-daily-task-allocation-management-system":
    "Employee Daily Task Allocation Management System",
  "/blogs/blogdetail/rfid-based-bus-number-announce-system-for-blind":
    "RFID Based Bus Number Announce System For Blind",
  "/blogs/blogdetail/to-do-list-app": "To Do List App",
  "/blogs/blogdetail/converters-app-project": "Converters App Project",
  "/blogs/blogdetail/ai-powered-communication-platform-for-deaf-and-mute":
    "AI Powered Communication Platform For Deaf And Mute",
  "/blogs/blogdetail/cloudvendor-app-using-java-springboot-using-mysql-jdbc":
    "CloudVendor App Using Java Spring Boot Using MySQL JDBC",

  "/Blogs/Blogdetail/employee-daily-task-allocation-management-system":
    "Employee Daily Task Allocation Management System",
  "/Blogs/Blogdetail/rfid-based-bus-number-announce-system-for-blind":
    "RFID Based Bus Number Announce System For Blind",
  "/Blogs/Blogdetail/to-do-list-app": "To Do List App",
  "/Blogs/Blogdetail/converters-app-project": "Converters App Project",
  "/Blogs/Blogdetail/ai-powered-communication-platform-for-deaf-and-mute":
    "AI Powered Communication Platform For Deaf And Mute",
  "/Blogs/Blogdetail/cloudvendor-app-using-java-springboot-using-mysql-jdbc":
    "CloudVendor App Using Java Spring Boot Using MySQL JDBC",
  "/admin": "Admin Dashboard",
  "/admin/contact-messages": "Contact Messages",
  "/admin/feedback-messages": "Feedback Messages",
  "/admin/project-likes": "Praveen's Project Likes",
  "/admin/portfolio-analytics": "Portfolio Analytics",
  "/admin/project-sharing-analytics": "Project Sharing Analytics",
  "/admin/blog-sharing-analytics": "Blog Sharing Analytics",
  "/admin/event-sharing-analytics": "Event Sharing Analytics",
  "/admin/events": "Events Overview",
  "/admin/events/all": "All Events Management",
  "/admin/events/registrations": "Event Registrations",
  "/admin/share-analytics": "Project Sharing Analytics",
  "/admin/settings": "Admin Settings",
};

// Normalized lowercase lookup map for robust case-insensitive and slash-agnostic matching
const normalizedTitleMap = Object.entries(titleMap).reduce((acc, [path, title]) => {
  const normalizedKey = path.toLowerCase().replace(/\/+$/, "") || "/";
  acc[normalizedKey] = title;
  return acc;
}, {});

const TitleManager = () => {
  const location = useLocation();

  useEffect(() => {
    const rawPath = location.pathname;
    const normalizedPath = rawPath.toLowerCase().replace(/\/+$/, "") || "/";

    if (normalizedPath === "/") {
      document.title = titleMap["/"] || "Praveen Kumar";
      return;
    }

    let pageTitle = titleMap[rawPath] || normalizedTitleMap[normalizedPath];

    if (!pageTitle) {
      if (normalizedPath.startsWith("/track/") || normalizedPath.startsWith("/contact-messages/")) {
        pageTitle = "Contact Details & Track";
      } else if (normalizedPath.startsWith("/admin")) {
        pageTitle = "Admin Panel";
      } else {
        pageTitle = "Page Not Found";
      }
    }

    document.title = `${pageTitle} | ${TITLE_SUFFIX}`;
  }, [location.pathname]);

  return null;
};

const AppContent = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");

  return (
    <>
      <TitleManager />
      {!isAdminRoute && <VisitorTracker />}
      {!isAdminRoute && <Navbar />}
      {!isAdminRoute && <CookieBanner />}
      {!isAdminRoute && <FeedbackPopup />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/internships" element={<Internships />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/book-session" element={<BookSession />} />
        <Route path="/events" element={<Events />} />
        <Route path="/events/eventdetail/:slug" element={<EventDetail />} />
        <Route path="/events/eventdetail/:slug/book" element={<EventBooking />} />
        <Route path="/under-construction" element={<UnderConstruction />} />
        <Route path="/track/:id" element={<TrackPage />} />
        <Route path="/contact-messages/:id" element={<TrackPage />} />
        <Route path="/admin/*" element={<AdminProtectedRoute><Admin /></AdminProtectedRoute>} />

        <Route
          path="/projects/projectdetail/employee-daily-task-allocation-management-system"
          element={<EmployeeDailyTask />}
        />
        <Route
          path="/projects/projectdetail/converters-app-project"
          element={<ConvertersAppProject />}
        />
        <Route
          path="/projects/projectdetail/rfid-based-bus-number-announce-system-for-blind"
          element={<RFIDBasedBusNumberAnnounceSystemForBlind />}
        />
        <Route
          path="/projects/projectdetail/to-do-list-app"
          element={<ToDoListApp />}
        />
        <Route
          path="/projects/projectdetail/smart-expense"
          element={<SmartExpense />}
        />
        <Route
          path="/projects/projectdetail/vista-holidays"
          element={<VistaHolidays />}
        />
        <Route
          path="/projects/projectdetail/docu-vault"
          element={<DocuVault />}
        />
        <Route
          path="/projects/projectdetail/Docu-Vault"
          element={<DocuVault />}
        />
        <Route
          path="/projects/projectdetail/ai-powered-communication-platform-for-deaf-and-mute"
          element={<AiPoweredCommunication />}
        />
        <Route
          path="/projects/projectdetail/tic-tac-toe-app"
          element={<TicTacToeApp />}
        />
        <Route
          path="/projects/projectdetail/notes-app"
          element={<PKNotesApp />}
        />
        <Route
          path="/projects/projectdetail/cloudvendor-app-using-java-springboot-using-mysql-jdbc"
          element={<CloudVendorApp />}
        />
        <Route path="/ops-mind-ai" element={<OpsMindAI />} />
        <Route path="/ai-ad-creative-generator" element={<AIAdCreativeGenerator />} />

        <Route path="/projects/projectdetail/aeroglass-productlanding-page"element={<AeroGlassProductLandingPage />}/>

        <Route path="/projects/projectdetail/easy-hub"element={<EasyHub />}/>

        <Route path="/projects/projectdetail/instagram-clone"element={<InstagramClone />}/>

        <Route path="/projects/projectdetail/linkedin-clone"element={<LinkedInClone />}/>

        <Route path="/projects/projectdetail/neon-bite-food-Delivery"element={<NeonBiteFoodDelivery />}/>

        <Route path="/projects/projectdetail/netflix-clone"element={<NetflixClone />}/>

        <Route path="/projects/projectdetail/spotify-clone"element={<SpotifyClone />}/>

        <Route path="/projects/projectdetail/tap-academy-clone"element={<TapAcademyClone />}/>

        <Route path="/projects/projectdetail/vortex-college-fest"element={<VortexCollegeFest />}/>

        <Route
          path="/certificates/certificatedetail/google-certificates"
          element={<GoogleCertificates />}
        />
        <Route
          path="/certificates/certificatedetail/microsoft-certificate"
          element={<MicrosoftCertificates />}
        />
        <Route
          path="/certificates/certificatedetail/linkedin-certificate"
          element={<LinkedInCertificates />}
        />
        <Route
          path="/certificates/certificatedetail/onlinewebinar-certificate"
          element={<OnlineWebinarCertificates />}
        />
        <Route
          path="/certificates/certificatedetail/infosys-springboard-certificates"
          element={<InfosysSpringboardCertificates />}
        />
        <Route
          path="/certificates/certificatedetail/guvi-certificates"
          element={<GuviCertificates />}
        />
        <Route
          path="/certificates/certificatedetail/hacker-rank-certificates"
          element={<HackerRankCertificates />}
        />
        <Route
          path="/certificates/certificatedetail/great-learning-certificates"
          element={<GreatLearningCertificates />}
        />
        <Route
          path="/certificates/certificatedetail/udemy-certificates"
          element={<UdemyCertificates />}
        />
        <Route
          path="/Certificates/Certificatedetail/one-roadmap-certificate"
          element={<OneRoadmapCertificate />}
        />
        <Route
          path="/Certificates/Certificatedetail/aws-certificates"
          element={<AwsCertificates />}
        />

        <Route
          path="/blogs/blogdetail/employee-daily-task-allocation-management-system"
          element={<BlogDetail />}
        />
        <Route
          path="/blogs/blogdetail/rfid-based-bus-number-announce-system-for-blind"
          element={<BlogRFIDBlind />}
        />
        <Route path="/blogs/blogdetail/to-do-list-app" element={<BlogToDoList />} />
        <Route
          path="/blogs/blogdetail/converters-app-project"
          element={<BlogConvertersApp />}
        />
        <Route
          path="/blogs/blogdetail/ai-powered-communication-platform-for-deaf-and-mute"
          element={<AIPoweredCommunicationBlog />}
        />
        <Route
          path="/blogs/blogdetail/cloudvendor-app-using-java-springboot-using-mysql-jdbc"
          element={<CloudVendorAppBlog />}
        />

        <Route path="/thank-you" element={<ThankYou />} />
        <Route path="/feedback-success" element={<FeedbackSuccess />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/my-activity" element={<MyActivity />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/terms" element={<TermsConditions />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="*" element={<NotFound />} />
      </Routes>

      {!isAdminRoute && <Footer />}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;